<template>
  <div ref="resize" class="resize">
    <el-card shadow="never" ref="card" class="card">
      <el-row class="el-row">
        <template v-if="assignOptions.headerSlot">
          <el-row>
            <slot name="header"></slot>
          </el-row>
        </template>
        <template v-else>
          <el-form :inline="true" v-if="assignOptions.headerMenu && assignOptions.advanceSearch"
            class="form advancedSearchBtn">
            <el-button-group class="button-group">
              <el-button class="mr0" type="primary" size="small" :icon="'el-icon-search'"
                @click="headerBtnFun('queryBtn')" v-if="assignOptions.queryBtn">查询</el-button>
              <el-button type="primary" class="demo-form-inline advanceBtn" size="small"
                icon="icon el-icon-shaixuan icon-shaixuan" v-if="assignOptions.advanceBtn" @click="advanceBtnFun">搜索
              </el-button>
              <slot name="headerBtnLeft"></slot>
            </el-button-group>
          </el-form>
          <el-form @submit.native.prevent @keyup.enter.native="headerBtnFun('queryBtn')" :inline="true" ref="form"
            :model="form" v-if="assignOptions.headerMenu" :style="
              'marginRight:' + (assignOptions.advanceSearch ? '0' : 0) + 'px'
            " class="form baseSearch">
            <el-form-item :prop="assignOptions.fuzzQueryField" label="查询" v-if="assignOptions.queryBtn">
              <lr-input v-model="form[assignOptions.fuzzQueryField]" :placeholder="'请输入搜索内容'" />
            </el-form-item>
            <slot name="queryLeft" :form="form"></slot>
            <template v-for="(item, index) in headerBtn">
              <el-button v-if="
                  assignOptions[item.btnType] === true ||
                  assignOptions[item.btnType] === false
                    ? assignOptions[item.btnType]
                    : item.show
                " :key="index" :type="item.type" :icon="item.icon" @click="headerBtnFun(item.btnType)">{{ item.label }}
              </el-button>
            </template>
          </el-form>
          <transition name="el-zoom-in-top">
            <el-form :inline="true" @submit.native.prevent @keyup.enter.native="headerBtnFun('queryBtn')"
              ref="advanceSearchForm" :model="advanceSearchForm" v-show="
                assignOptions.headerMenu &&
                assignOptions.advanceSearch &&
                advanceSearchDefaultVisiable
              " class="advancedSearch form">
              <template v-for="(item, index) in assignOptions.column"
                v-if="assignOptions.advanceSearchDefaultColsVisiable">
                <el-form-item :key="index" :label="item.label" :prop="item.field" v-show="item.advanceSearch !== false">
                  <lr-input :itemOptions="item" v-model="advanceSearchForm[item.field]" />
                  <!-- <el-input size="mini" v-model="form[item.field]" ></el-input> -->
                </el-form-item>
              </template>
              <slot name="advanceQueryLeft" :form="advanceSearchForm"></slot>
            </el-form>
          </transition>
        </template>
      </el-row>
      <span class="pr" ref="tableContainer">
        <el-checkbox class="check-page-all check-page-all-absolute"
          v-if="assignOptions.selection&&assignOptions.slotCheck" v-model="checkPageAll"
          @change="checkPageAllEv($event)"></el-checkbox>
        <el-table v-loading="assignOptions.loading"  :data="tableData" 
          style="width: 100%; border: 1px solid #d4d4d4;" 
          :header-cell-style="{background:'#e1edff', height: '40px'}"
          @row-click="rowClick"  @row-dblclick="dbClick"
          @row-contextmenu="rowRightClick" @sort-change="sortChange" @expand-change="expandChange"
          :tree-props="assignOptions.treeProps" @select="select" @select-all="selectAll"
          @selection-change="handleSelectionChange" :load="load" :border="assignOptions.border" :height="tableHeight"
          :row-key="assignOptions.rowKey" :show-summary="assignOptions.showSummary" :summary-method="tableSummaryMethod"
          :default-expand-all="assignOptions.expandAll" ref="table" :lazy="assignOptions.lazy"
          :size="assignOptions.size" highlight-current-row :header-cell-class-name="cellClass">

          <el-table-column v-if="assignOptions.selection&&assignOptions.slotCheck" align="left" type="selection">
            <template v-if="assignOptions.slotCheck" slot-scope="scope">
              <el-checkbox v-model="scope.row.pageCheck" @change="pageCheckEv(scope)"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column v-else-if="assignOptions.selection" align="left" type="selection">
          </el-table-column>
          <el-table-column v-if="assignOptions.index&&assignOptions.pagination" fixed :width="60" label="序号"
            align="center" type="index">
            <template slot-scope="scope">
              <span>{{(pages.PageIndex-1)*pages.PageSize+scope.$index+1}}</span>
            </template>
          </el-table-column>
          <el-table-column v-else-if="assignOptions.index" fixed :width="60" label="序号" align="center" type="index">
          </el-table-column>
          <el-table-column v-if="assignOptions.expand" align="left" type="expand">
            <template slot-scope="scope">
              <slot name="expandRow" :data="scope.row"></slot>
            </template>
          </el-table-column>
          <template v-for="(item, index) in assignOptions.column">
            <el-table-column :header-align="assignOptions.headerAlign" :fixed="item.fixed" v-if="!item.hide"
              :min-width="item.minWidth" :width="item.width" :sortable="item.sortable ? 'custom' : false"
              :prop="item.field" :key="index" :align="item.align" :label="item.label" show-overflow-tooltip>
              <template slot-scope="scope">
                <slot v-if="item.slot" :name="item.field" :data="scope.row" :style="'color:' + item.color"></slot>
                <span v-else-if="item.filterType === 'date' || item.filterDate"
                  :style="{ color: item.color }">{{ scope.row[item.field] | datetimeFormat() }}</span>
                <span v-else :style="{ color: item.color }">{{
                item.formatter
                  ? item.formatter(scope.row)
                  : Dic(scope.row[item.field],item)
              }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column v-if="assignOptions.menuBtn" fixed="right" align="center" :label="assignOptions.menuBtnLabel"
            :width="assignOptions.menuBtnWidth">
            <template slot-scope="scope">
              <el-button plain type="primary" @click="handleEdit(scope.row)" v-if="assignOptions.menuEditBtn"
                size="mini">编辑</el-button>
              <el-button plain type="danger" @click="handleDelete(scope.row)" v-if="assignOptions.menuDeleteBtn"
                size="mini">删除</el-button>
              <slot name="menuAction" :data="scope.row"></slot>
            </template>
          </el-table-column>
        </el-table>
      </span>

      <template v-if="assignOptions.paginationSlot">
        <el-row>
          <slot name="pagination"></slot>
        </el-row>
      </template>
      <template v-else>
        <el-pagination v-if="assignOptions.pagination" class="pagination-container" background
          @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.PageIndex"
          :page-sizes="pages.PageSizes||[10,20,30,50,100,500,1000]" :page-size="pages.PageSize"
          :layout="assignOptions.layout" :total="pages.total">
        </el-pagination>
      </template>
    </el-card>
    <el-dialog :width="
        assignOptions.dialogWidth ? assignOptions.dialogWidth + '%' : '70%'
      " :close-on-click-modal="false" :title="dialogType === 'add' ? '新增' : '编辑'" :visible.sync="dialogFormVisible">
      <lr-form :form="dialogForm" :rules="dialogFormRules" :column="assignOptions.column"></lr-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="diaLogSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    addResizeListener,
    removeResizeListener,
  } from "element-ui/src/utils/resize-event";
  export default {
    name: "lrCrud",
    components: {},
    props: {
      tableData: {
        type: Array,
        default: () => [],
      },
      options: {
        type: Object,
        default: {
          column: {
            type: Array,
            default: () => [],
          },
        },
      },
      pages: {
        PageIndex: 1,
        PageSize: 20,
        total: 0,
        PageSizes: [10, 20, 50, 100],
      },
      summaryMethod: Function,
    },
    computed: {
      //props的特性，它只在没有传参时才会被读取，并不会为你的参数对象补齐属性,所以用计算属性获取
      assignOptions() {
        return Object.assign({
            menuBtn: false, //是否开启操作列
            menuBtnLabel: "操作", //操作列名称
            menuEditBtn: false, //是否显示编辑按钮
            menuBtnWidth: 150, //操作列宽度
            menuDeleteBtn: false, //是否显示删除按钮
            autoQuery: true, //是否自动加载表格
            index: false, //是否开启序号列
            selection: false, //是否多选
            expand: false, //是否展开行
            pagination: true, //分页是否开启
            height: "auto", //表格高度
            headerMenu: true, //显隐头部查询条件
            fuzzQueryField: "Search", //模糊查询默认字段名
            advanceSearch: true, //开启高级筛选
            headerSlot: false, //自定义头部
            border: true,
            size: "mini",
            headerAlign: "left",
            rowKey: "ID",
            paginationSlot: false, //自定义分页
            advanceSearchDefaultColsVisiable: false, //开启高级筛选的列查询条件
            handleQuery: false,
            expandAll: false, //是否展开全部
            advanceBtn: false,
            queryBtn: false,
            loading: false,
            treeProps: {
              children: 'children',
              hasChildren: 'hasChildren'
            },
            lazy: false,
            parentRowKey: 'ParentID',
            slotCheck: false,
            showSummary: false,
            layout: 'total, sizes, prev, pager, next, jumper',
            hideCheckAll: false,
          },
          this.options
        );
      },
      advanceBtnIcon() {
        return this.advanceSearchDefaultVisiable ?
          "el-icon-caret-top" :
          "el-icon-caret-bottom";
      },
      /*assignPages(){
        return Object.assign({
          pageIndex:1,
          pageSize:10,
          total:0,
        },this.pages);
      },*/
    },
    data() {
      return {
        form: {},
        advanceSearchForm: {},
        params: {},
        tableHeight: "auto",
        headerBtn: [
          // {label:'查询',btnType:'queryBtn',show:true,icon:'el-icon-search',type:'primary'},
          {
            label: "重置",
            btnType: "resetBtn",
            show: false,
            icon: "el-icon-delete",
            type: "danger",
          },
          {
            label: "新增",
            btnType: "addBtn",
            show: false,
            icon: "el-icon-plus",
            type: "success",
          },
          {
            label: "打印",
            btnType: "printBtn",
            show: false,
            icon: "el-icon-printer",
            type: "primary",
          },
          {
            label: "导出",
            btnType: "exportBtn",
            show: false,
            icon: "el-icon-download",
            type: "success",
          },
          {
            label: "导入",
            btnType: "importBtn",
            show: false,
            icon: "el-icon-upload2",
            type: "info",
          },
        ],
        advanceSearchDefaultVisiable: false, //高级筛选显示
        //advanceBtnIcon:'el-icon-caret-bottom',
        copyAdvanceSearchForm: {},
        dialogType: "add", //弹窗默认类型
        dialogFormVisible: false, //弹窗显隐
        dialogForm: {},
        dialogWidth: "",
        copyPages: {},
        initForm: {},
        initAdvanceSearchForm: {},
        selection: [],
        dialogFormRules: {},
        selectRow: {},
        selectedArr: [],
        parentArr: [],
        selectionAllData: [],
        checkPageAll: false,
      };
    },
    created() {
      if (
        this.assignOptions &&
        this.assignOptions.height &&
        this.assignOptions.height != "auto"
      ) {
        this.tableHeight = this.assignOptions.height;
      }
    },
    mounted() {

      //获取查询条件参数
      if (this.$listeners["getForm"]) {
        this.$emit("getForm", this.form);
      }
      if (this.assignOptions.advanceSearchDefaultVisiable) {
        this.advanceSearchDefaultVisiable = this.assignOptions.advanceSearchDefaultVisiable;
      }
      //根据配置项添加form的rules
      this.assignOptions.column.forEach((item, index) => {
        if (item.required) {
          this.$set(this.dialogFormRules, item.field, [{
            required: true,
            message: "请输入" + item.field,
            trigger: "blur"
          }, ]);
        }
      });
      this.initForm = {
        ...this.form
      };
      this.initAdvanceSearchForm = {
        ...this.advanceSearchForm
      };
      this.$nextTick(() => {
        if (this.assignOptions.autoQuery) {
          this.loadData();
        }
      });
      this.updateTableHeight();
      addResizeListener(this.$refs.resize, this.updateTableHeight);
    },
    beforeDestroy() {
      removeResizeListener(this.$refs.resize, this.updateTableHeight);
    },
    methods: {
      cellClass() {
        if (this.assignOptions.hideCheckAll) {
          return 'DisableSelection'
        }
      },
      tableSummaryMethod(param) {
        this.$nextTick(() => {
          this.$refs.table.doLayout();
        })

        //如果自己写逻辑则调用summaryMethod方法
        if (typeof this.summaryMethod === "function")
          return this.summaryMethod(param);
        const {
          columns,
          data
        } = param;
        const sums = [];
        if (columns.length > 0) {
          columns.forEach((column, index) => {
            let currItem = this.sumColumnList.find(
              item => item.name === column.property
            );
            if (index === 0) {
              sums[index] = this.tableOption.sumText || config.sumText;
            } else if (currItem) {
              switch (currItem.type) {
                case "count":
                  sums[index] = "计数:" + data.length;
                  break;
                case "avg":
                  let avgValues = data.map(item => Number(item[column.property]));
                  let nowindex = 1;
                  sums[index] = avgValues.reduce((perv, curr) => {
                    let value = Number(curr);
                    if (!isNaN(value)) {
                      return (perv + curr) / nowindex++;
                    } else {
                      return perv;
                    }
                  }, 0);
                  sums[index] = "平均:" + sums[index].toFixed(2);
                  break;
                case "sum":
                  let values = data.map(item => Number(item[column.property]));
                  sums[index] = values.reduce((perv, curr) => {
                    let value = Number(curr);
                    if (!isNaN(value)) {
                      return perv + curr;
                    } else {
                      return perv;
                    }
                  }, 0);
                  sums[index] = "合计:" + sums[index].toFixed(2);
                  break;
              }
            } else {
              sums[index] = "-";
            }
          });
        }
        return sums;
      },
      formatter() {
        return 123;
      },
      getStyleValue(style) {
        if (style && style.slice(-2) == "px") {
          style = Number(style.slice(0, -2));
          if (!isNaN(style)) return style;
        } else {
          style = Number(style);
          if (!isNaN(style)) return style;
        }
        return 0;
      },
      updateTableHeight() {
        this.$refs.table.doLayout();
        if (
          this.assignOptions &&
          (this.assignOptions.height ||
            this.assignOptions.height === "auto")
        ) {
          this.$nextTick(() => {
            this.calcTableHeight();
          });
        }
      },
      //表格高度自定义
      calcTableHeight() {
        let card = this.$refs.card;
        let totalHeight = 0;
        let table = this.$refs.table;
        let tableContainer = this.$refs.tableContainer;
        if (!table) return;
        for (let i = 0; i < card.$el.children[0].children.length; i++) {
          let child = card.$el.children[0].children[i];

          // if (!child.__vue__ || child.__vue__ != table) {
          if (!child || child != tableContainer) {
            let el = child;
            let height = el.offsetHeight; //元素占用高度，含border，不含margin
            let style = window.getComputedStyle(el, null);
            let marginTop = this.getStyleValue(style.marginTop);
            height += marginTop;

            let marginBottom = this.getStyleValue(style.marginBottom);
            height += marginBottom;
            totalHeight += height;
          }
        }
        let tableStyle = window.getComputedStyle(table.$el, null);
        let tableMarginTop = this.getStyleValue(tableStyle.marginTop);
        let tableMarginBottom = this.getStyleValue(tableStyle.marginBottom);
        if (
          this.assignOptions &&
          this.assignOptions.height &&
          this.assignOptions.height != "auto"
        ) {
          //this.tableHeight = this.assignOptions.height;
        } else {
          this.tableHeight =
            this.$el.offsetHeight -
            totalHeight -
            tableMarginTop -
            tableMarginBottom;
        }

      },
      //查询表格数据
      loadData(pages) {
        //if (this.assignOptions.autoQuery) {
        this.$nextTick(() => {
          this.$refs.table.doLayout();
        })
        if (pages) {
          this.pages = pages
        } else if (this.pages) {
          this.pages.PageIndex = 1;
        }
        this.copyPages = {
          ...this.pages
        };
        delete this.copyPages.PageSizes;
        delete this.copyPages.total;
        this.$emit(
          "loadData",
          Object.assign({},
            this.copyPages,
            this.params,
            this.form,
            this.advanceSearchForm
          )
        ); //PublicParams,
        //}
      },
      //弹窗确定按钮
      diaLogSubmit() {
        this.$emit("diaLogSubmit", this.dialogForm);
      },
      getform() {
        this.copyPages = {
          ...this.pages
        };
        delete this.copyPages.PageSizes;
        delete this.copyPages.total;

        return Object.assign({},
          this.copyPages,
          this.params,
          this.form,
          this.advanceSearchForm
        )
      },
      queryTable() {
        this.loadData();
      },
      //头部按钮点击
      headerBtnFun(funName) {
        //查询方法
        if (funName === "queryBtn") {
          this.assignOptions.autoQuery = true;
          //自定义查询方法
          if (this.pages) {
            this.pages.PageIndex = 1;
          }
          if (this.$listeners["handleQuery"]) {
            this.copyPages = {
              ...this.pages
            };
            delete this.copyPages.PageSizes;
            delete this.copyPages.total;
            this.$emit(
              "handleQuery",
              Object.assign({},
                this.copyPages,
                this.params,
                this.form,
                this.advanceSearchForm
              )
            );
          } else {
            this.loadData(this.pages);
          }
          //重置方法
        } else if (funName === "resetBtn") {
          this.form = {
            ...this.initForm
          };
          this.advanceSearchForm = {
            ...this.initAdvanceSearchForm
          };
          //this.$refs['form'].resetFields();
          //this.$refs['advanceSearchForm'].resetFields();
          //this.copyAdvanceSearchForm = {...this.advanceSearchForm}
          //新增方法
        } else if (funName === "addBtn") {
          this.handleAdd();
          //this.dialogType = 'add';
          //this.dialogForm = {};
          //this.dialogFormVisible=true;
          //this.$emit('handleMenu','add');
        } else if (funName === "printBtn") {
          this.$emit("handleMenu", "print");
        } else if (funName === "exportBtn") {
          this.$emit("handleMenu", "export");
        } else if (funName === "importBtn") {
          this.$emit("handleMenu", "import");
        }
      },
      //显示高级筛选内容
      advanceBtnFun() {
        this.advanceSearchDefaultVisiable = !this.advanceSearchDefaultVisiable;
        /*if(this.advanceBtnIcon==='el-icon-caret-bottom'){
          //this.advanceSearchForm = {...this.copyAdvanceSearchForm}
          this.advanceBtnIcon = 'el-icon-caret-top';
        }else{
          //this.copyAdvanceSearchForm = {...this.advanceSearchForm}
          //this.advanceSearchForm = {};
          this.advanceBtnIcon = 'el-icon-caret-bottom';
        }*/
        this.$nextTick(() => {
          this.calcTableHeight();
        });
      },
      //新增事件
      handleAdd() {
        this.dialogType = "add";
        this.dialogForm = {};
        this.dialogFormVisible = true;
      },
      //编辑事件
      handleEdit(data) {
        this.dialogType = "edit";
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.dialogForm = data;
        });
        this.$emit("tableEdit", data);
      },
      //删除事件
      handleDelete(data) {
        this.$emit("tableDelete", data);
      },
      select(selection, row) {
        this.$emit("select", selection, row);
      },
      selectAll(selection) {
        this.$emit("selectAll", selection);
      },
      //多选事件
      handleSelectionChange(selection) {
        this.selection = selection;
        this.$emit("selectionChange", selection);
      },
      //翻页
      handleSizeChange(size) {
        this.pages.PageSize = size;
        this.copyPages = {
          ...this.pages
        };
        delete this.copyPages.PageSizes;
        delete this.copyPages.total;
        //自定义查询方法
        if (this.$listeners["handleQuery"]) {
          this.$emit(
            "handleQuery",
            Object.assign({},
              this.copyPages,
              this.params,
              this.form,
              this.advanceSearchForm
            )
          );
        } else {
          this.loadData(this.pages);
        }
      },
      //翻页
      handleCurrentChange: function (currentPage) {
        this.pages.PageIndex = currentPage;
        this.copyPages = {
          ...this.pages
        };
        delete this.copyPages.PageSizes;
        delete this.copyPages.total;
        //自定义查询方法
        if (this.$listeners["handleQuery"]) {
          this.$emit(
            "handleQuery",
            Object.assign({},
              this.copyPages,
              this.params,
              this.form,
              this.advanceSearchForm
            )
          );
        } else {
          this.loadData(this.pages);
        }
      },
      rowClick(row, column, e) {
        // if(this.assignOptions.selection)
        // {
        //    this.$refs.table.toggleRowSelection(row)
        // }
        this.$refs.table.setCurrentRow(row);
        this.$emit("rowClick", JSON.parse(JSON.stringify(row)), column, e);
      },
       dbClick(row, column, e){
      this.$refs.table.setCurrentRow(row);
      this.$emit("dbClick", JSON.parse(JSON.stringify(row)), column, e);
    },
      rowRightClick(row, column, e) {
        e.preventDefault();
        this.$refs.table.setCurrentRow(row);
        //this.position = { clientY: e.clientY, clientX: e.clientX };
        this.$emit("rowRightClick", JSON.parse(JSON.stringify(row)), column, e);
      },
      //排序
      sortChange(column) {
        if (!column.prop) {
          delete this.params.order;
          delete this.params.prop;
        } else {
          Object.assign(this.params, {
            order: column.order,
            prop: column.prop
          });
        }
        this.loadData();
      },
      //展开行事件
      expandChange(row, expanded) {
        this.$emit("expandChange", row, expanded);
      },
      setCurrentRow(row) {
        this.$refs.table.setCurrentRow(row)
      },
      queryForm() {
        return Object.assign({}, this.form, this.advanceSearchForm);
      },
      load(tree, treeNode, resolve) {
        this.$emit('load', tree, treeNode, resolve)
      },
      Dic(value, item) {
        if ((item.type === 'select' || item.type === 'radio') && item.options) {
          let dicValue = '';
          item.options.forEach((item, index) => {
            if (item.Value === value) {
              dicValue = item.Name
            }
          })
          return dicValue ? dicValue : value;
        } else {
          return value
        }
      },
      getParent(data2, nodeId2) {
        var arrRes = []
        if (data2.length === 0) {
          if (nodeId2) {
            arrRes.push(data2)
          }
          return arrRes
        }
        let rev = (data, nodeId) => {
          for (var i = 0, length = data.length; i < length; i++) {
            let node = data[i]
            if (node[this.assignOptions.rowKey] === nodeId) {
              arrRes.push(node)
              rev(data2, node[this.assignOptions.parentRowKey])
              break
            } else {
              if (node.children) {
                rev(node.children, nodeId)
              }
            }
          }
          return arrRes
        }
        arrRes = rev(data2, nodeId2)
        return arrRes
      },
      /**
       * 页面选择
       */
      // 总选框事件
      checkPageAllEv(item) {
        let checkAll = (data, checked) => {
          for (let x of data) {
            this.$set(x, 'pageCheck', checked)
            //x.pageCheck = checked
            if (x.children) {
              checkAll(x.children, checked)
            }
          }
        }
        if (item === true) {
          checkAll(this.tableData, true)
        } else {
          checkAll(this.tableData, false)
        }
        this.selectionAllData = [];
        this.mapChecked(this.tableData)
        this.$emit('pageCheck', this.selectionAllData)
      },
      // 遍历json数据
      isCheckAllEv(data) {
        let isCheckAll = true
        let fn = data => {
          for (let x of data) {
            if (!x.pageCheck) {
              //if (x.pageCheck === false) {
              isCheckAll = false
              return isCheckAll
            }
            if (x.children) {
              fn(x.children)
            }
          }
        }
        fn(data)
        return isCheckAll
      },
      // 子选框事件
      pageCheckEv(scope) {
        // 如果有子项，则子项的选框选择跟当前一致
        if (scope.row.children) {
          this.handleCheckAll(scope.row, scope.row.pageCheck)
        }
        // 查找父级选框
        this.getParent(this.tableData, scope.row[this.assignOptions.rowKey]).forEach((item, i) => {
          if (!item.children) {
            this.$set(item, 'pageCheck', scope.row.pageCheck)
            //item.pageCheck = scope.row.pageCheck
          } else {
            var num = 0
            item.children.forEach((item, i) => {
              if (item.pageCheck === true) {
                num += 1
              }
            })
            if (num === item.children.length) {
              this.$set(item, 'pageCheck', true)
              //item.pageCheck = true
            } else {
              this.$set(item, 'pageCheck', false)
              //item.pageCheck = false
            }
          }
        })

        // 是否所有子项都已经勾选
        if (this.isCheckAllEv(this.tableData) === true) {
          this.checkPageAll = true
        } else {
          this.checkPageAll = false
        }
        this.selectionAllData = [];
        this.mapChecked(this.tableData)
        this.$emit('pageCheck', this.selectionAllData)
      },
      mapChecked(row) {
        if (row instanceof Array) {
          row.forEach((item, index) => {
            this.mapChecked(item)
          })
        } else {
          if (row.children) {
            if (row.pageCheck) {
              this.selectionAllData.push(row)
            }
            this.mapChecked(row.children)
          } else {
            if (row.pageCheck) {
              this.selectionAllData.push(row)
            }
          }
        }
      },
      clearSelection() {
        this.$refs.table.clearSelection()
      },
      handleCheckAll(row, checked) {
        this.$set(row, 'pageCheck', checked)
        //row.pageCheck = checked
        if (row.children) {
          let that = this
          row.children.forEach((element, i) => {
            that.handleCheckAll(row.children[i], checked)
          })
        }
      },
    },
  };

</script>

<style scoped lang="scss">
  .mr0 {
    margin-right: 0px;
  }

  >>>.icon-shaixuan {
    font-size: 12px;
  }

  >>>.button-group {
    .icon {
      font-size: 12px !important;
    }

    button {
      margin-left: 0;
      min-height: 34px;
    }
  }

  .resize {
    /deep/ .DisableSelection:first-child>.cell {
      display: none !important;
    }

    height: 100%;
    width:100%;
    overflow: auto;

    .card {
      height: 100%;

      .extendBtn {
        width: 100%;
        margin-bottom: 10px;
      }

      .el-table {
        margin-top: 5px;
      }

      .el-row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        .advancedSearch {
          position: absolute;
          top: 38px;
          background: white;
          box-shadow: #858585 4px 4px 6px;
          border: 1px solid rgb(232, 233, 234);
          padding: 10px;
          border-radius: 5px;
          margin-left: 0.5%;
          width: 99% !important;
          z-index: 9;
        }

        .form {
          width: auto;
          display: inline-block;
          font-size: 0;
        }

        .baseSearch {
          flex: 1;
          text-align: right;

          //margin-bottom: 5px;
          button {
            margin-top: 2px;
          }
        }

        .advanceBtn {
          // background:rgb(6,197,204);
          // color: white;
          // border: 1px solid #06c5cc;
          //margin-left:10px;
        }

        .advancedSearchBtn {
          // width:160px;
          // top: -1px;
          // position:absolute;
          // right:0
        }
      }

      >>>.el-table .caret-wrapper {
        height: 20px;

        .ascending {
          top: -2px;
        }

        .descending {
          bottom: -2px;
        }
      }

      >>>.el-card__body {
        padding: 0;
      }

      border: none;

      >>>.el-form-item {
        //margin: 0.5px 0px 6.5px 10px ;
        margin: 0px 0px 0 10px;

        .el-form-item__label {
          font-weight: 100;
          text-indent: 5px;
          padding: 0 6px 0 0;
          //width: 100px;
        }
      }

      >>>.pagination-container {
        margin: 0;
        text-align: center;
        padding: 10px 16px;

        .el-pagination {
          text-align: right;
        }
      }
    }
  }

  >>>.el-table [class*=el-table__row--level] .el-table__expand-icon {
    font-size: 16px;
    float: right
  }

  >>>.el-table__placeholder {
    width: 0;
  }

  .pr {
    position: relative;

    .check-page-all {
      position: absolute;
      left: 11px;
      height   : 25px;
      width: 25px;
      top: 15px;
      z-index: 999;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/LrCrud/index.vue